module.exports = __webpack_public_path__ + "img/budget-remaining-saving.79da1cd1.svg";